<template>
  <div>
    <Head />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  cat_href,
  jd_href,
  city_href,
  operation_href,
  prescription_href,
  prescription_search_href,
  express_href,
  agreement_href,
  protect_href,
  site_href,
} from "../assets/config/img";
import Head from "../components/Head.vue";
import Footer from "../components/Footer.vue";
export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  components: {
    Head,
    Footer,
  },
  data() {
    return {
    
    };
  },
  mounted() {
   
  },
  methods: {
    logo_click() {
      if (this.cgmUserVO) {
        let userId = JSON.parse(this.cgmUserVO).userId;
        this.axios
          .get("/cgmOrder/getOrderCount", {
            params: {
              userId,
            },
          })
          .then((res) => {
            if (res.data.code == 200) {
              this.configFlag = res.data.data;
              if(res.data.data > 0){
                this.$router.push("/ConfigMedicine");
              }else{
                this.$router.push("/Firstindex");
              }
            }
          });
        }
    },
    login_click() {
      this.$router.push("/Login");
    },
    register_click() {
      this.$router.push("/Register");
    },
    cat_href_click() {
      window.open(cat_href);
    },
    jd_href_click() {
      window.open(jd_href);
    },
    city_href_click() {
      window.open(city_href);
    },
    operation_href_click() {
      window.open(operation_href);
    },
    prescription_href_click() {
      window.open(prescription_href);
    },
    prescription_search_href_click() {
      window.open(prescription_search_href);
    },
    express_href_click() {
      window.open(express_href);
    },
    agreement_href_click() {
      window.open(agreement_href);
    },
    protect_href_click() {
      window.open(protect_href);
    },
    site_href_click() {
      window.open(site_href);
    },
  },
};
</script>
<style lang="scss" scoped>
.head_style {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.head_height_style {
  height: 60px;
}

.head_style1 {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  cursor: pointer;
}

.head_margin_style {
  margin-right: 20px;
}

.logo_style {
  width: 140px;
  cursor: pointer;
}

.cat_style {
  width: 24px;
}

.login_style {
  background: rgb(229, 28, 81);
  color: #fff;
  font-weight: bold;
  border-radius: 100px;
  padding: 8px 16px;
  cursor: pointer;
}

.register_style {
  background: #409eff;
  color: #fff;
  font-weight: bold;
  border-radius: 100px;
  padding: 8px 16px;
  cursor: pointer;
}

.footer_style {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>